
import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { LeftPanelService } from '../services/left-panel.service';
import { UserService } from '../../../core/security/user.service';
import { NavigationService } from '../../../core/navigation.service';
import { AlertService, LoggerService, ResourceService, MfaService, gb } from 'sce-core';
import { ConfirmDialogService } from 'sce-core';
import { environment } from '../../../../environments/environment.sit';
import { saveAs } from 'file-saver'; // Don't forget to import the file-saver
import { HelpPopupComponent } from '../help-popup/help-popup.component';
import { SharedServiceRegistry } from '../../../shared/shared-service-registry';
import { ReceiptDataService } from '../../../shared/services/receipt/receipt-data.service';

const MCL_TENANT_ID = '0';
const MBM_TENANT_ID = '1';
const MCL_TENANT_NAME = 'Maersk Contract Logistics (MCL)';
const MBM_TENANT_NAME = 'Managed by Maersk (MbM)';
const SELECTED_TENANT_ID = 'tms_tenant_id';

@Component({
  selector: 'lfwms-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  animations: [
    trigger('openClose', [
      state('open', style({
        right: '350px',
      })),
      state('closed', style({
        right: '0px'
      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ])
  ]
})
export class ProfileComponent implements OnInit {

  public displayName: string;
  public displayCountry: any = {};
  public displayTenantID: string;
  public displayLanguage: any = {};
  public show: boolean = false;
  public cntryDropDownShow: boolean;
  public tenantIDDropDownShow: boolean;
  public langDropDownShow: boolean;
  public image_user = 'assets/images/icon-person.png';
  public displayPhotoBool: boolean = false;

  public countries: any[];
  public tenantIDs: any[] = [];
  public  languages: any[];
  private storers: any[];
  private selectedCountry: number;
  public selectedTenantID: string = '';
  private selectedLanguage: number;
  private selectedStorer: string;
  private showErrorLog: boolean;

  // MFA properties
  public mfaStatus: any = null;
  public mfaStatusLoading: boolean = false;
  public showMfaSetup: boolean = false;
  public mfaTestMode: boolean = true; // Set to false in production
  public currentUserName: string = '';
  public mfaFeatureEnabled: boolean = false;
  public mfaStatusText = 'Setup Needed';

  protected dataService: ReceiptDataService;

  constructor(private userService: UserService,
    private navService: NavigationService,
    private confirmDialogService: ConfirmDialogService,
    private resourceService: ResourceService,
    public leftPanelService: LeftPanelService,
    public loggerService: LoggerService,
    public alertService: AlertService,
    protected sharedServiceRegistry: SharedServiceRegistry,
    private mfaService: MfaService) {
  }

  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public ngOnInit() {
    this.updateUserPreference();
    this.checkForTenantIDRestriction();
    this.displayName = this.userService.userInfo.displayName;
    this.currentUserName = this.userService.userInfo.userName;
    if (this.userService.userInfo.photo) {
      this.image_user = this.userService.userInfo.photo;
      this.displayPhotoBool = true;
    }
    const gbInner = (gb as any).gb;
    // Check MFA feature flag
    this.mfaFeatureEnabled = gb.isOn('mfa-profile-enabled');
    if (this.mfaFeatureEnabled) {
      this.loadMfaStatus();
    }
  }

  checkForTenantIDRestriction() {
    this.navService.getAppPrivRestriction(8).subscribe((response: any) => {
      let ids: any;
      if (response.userRestrictions.length > 0) {
        ids = response.userRestrictions[0].restrictions.find((restriction: any) => {
          return restriction.restrictionTypeName === 'Tenant ID';
        });
        if (ids && ids.restrictionValue) {
          ids = ids.restrictionValue.split(',');
          for (let id of ids) {
            this.tenantIDs.push(this.getTenantDisplayName(id));
          }
          this.getSelectedTenantID();
        } else {
          this.tenantIDs = [];
        }
      }
    })
  }

  getTenantDisplayName(tenantID: string) {
    if (tenantID === MCL_TENANT_ID) {
      return MCL_TENANT_NAME;
    }
    return MBM_TENANT_NAME;
  }

  getSelectedTenantID() {
    const tenantID = localStorage.getItem(SELECTED_TENANT_ID);
    if (tenantID && this.tenantIDs.indexOf(this.getTenantDisplayName(tenantID)) !== -1) {
      this.displayTenantID = this.getTenantDisplayName(tenantID);
      this.selectedTenantID = tenantID;
    } else {
      this.displayTenantID = this.tenantIDs[0];
      this.selectedTenantID = this.getTenanIdFromDisplayName(this.displayTenantID);
      localStorage.setItem(SELECTED_TENANT_ID, this.selectedTenantID);
    }
    this.tenantIDs = this.tenantIDs.filter((tenant: any) => {
      return tenant !== this.displayTenantID;
    });
  }

  getTenanIdFromDisplayName(displayName: string) {
    if (displayName === MCL_TENANT_NAME) {
      return MCL_TENANT_ID;
    }
    return MBM_TENANT_ID;
  }

  // Logs the user out
  public logout() {
    if (this.navService.preventNavigation) {
      const dialogMsg = [`<b>` + this.resourceService.get('mn_data_lost_msg') + `</b>`, this.resourceService.get('mn_nav_confirm_msg')];
      this.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed) => {
        if (!isConfirmed) {
          return false;
        }
        this.navService.preventNavigation = false;
        this.userService.logout();

       });
      return;
    }
    // else
    this.userService.logout();
  }

  /* Save the selected language to backend.
    this.saveCntryLang() reloads homepage */
  private saveLang(language: any) {
    if (this.navService.preventNavigation) {
      const dialogMsg = [`<b>` + this.resourceService.get('mn_data_lost_msg') + `</b>`, this.resourceService.get('mn_nav_confirm_msg')];
      this.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed) => {
        if (!isConfirmed) {
          return false;
        }
        this.navService.preventNavigation = false;
        this.selectedLanguage = language.languageId;
        this.displayLanguage = language;
        this.saveCntryLang();

       });
      return;
    }
    // else
    this.selectedLanguage = language.languageId;
    this.displayLanguage = language;
    this.saveCntryLang();
  }

  private saveTenant(tenant: any) {
    this.selectedTenantID = this.getTenanIdFromDisplayName(tenant);
    this.displayTenantID = tenant;
    localStorage.setItem(SELECTED_TENANT_ID, this.selectedTenantID);

    // Reload the homepage
    window.location.href = environment.baseUrlUI;
  }

  private uponTenantDropdownClick() {
    if (this.tenantIDs.length === 0) {
      return;
    }
    this.tenantIDDropDownShow = !this.tenantIDDropDownShow;
    this.cntryDropDownShow=false;
    this.langDropDownShow=false;
  }

  /* Save the selected country to backend.
    this.saveCntryLang() reloads homepage */
  private saveCntry(country: any) {
    if (this.navService.preventNavigation) {
      const dialogMsg = [`<b>` + this.resourceService.get('mn_data_lost_msg') + `</b>`, this.resourceService.get('mn_nav_confirm_msg')];
      this.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed) => {
        if (!isConfirmed) {
          return false;
        }
        this.navService.preventNavigation = false;

          this.selectedCountry = country.countryId;
          this.displayCountry = country;
          this.saveCntryLang();
          localStorage.removeItem(SELECTED_TENANT_ID);
       });
      return;
    }
    // else
    this.selectedCountry = country.countryId;
    this.displayCountry = country;
    localStorage.removeItem(SELECTED_TENANT_ID);
    this.saveCntryLang();
  }

  /* This methods reads currently selected countryId and languageId
  and calls update preferences method for the user.
  Once save call is successfull it reloads homepage.*/
  private saveCntryLang() {
   // this.selectedLanguage = Number(this.selectedLanguage);
    this.userService.updatePreferences(
      this.selectedCountry,
      this.selectedLanguage)
      .subscribe((data: any) => {
        if(data && data.baseUrl && data.baseUrl !== window.location.origin ){
          window.location.href = data.baseUrl;
        } else {
          window.location.href = environment.baseUrlUI; // SIT URL changed
        }
      });
  }
   /*  This function fetches and sets Country list and Language list
    for use in Cntry/Lang change dropdowns */
  private retrieveCountryLangList() {
    this.userService.getEnabledCountries()
      .subscribe((data: any) => {
        this.countries = data;
        this.countries = this.countries.filter((cntry: any) => {
          return cntry.countryId !== this.userService.userInfo.defaultCountry;
        });
        for (const country of data) {
          if (country.countryId === this.userService.userInfo.defaultCountry) {
            this.displayCountry = country;
            break;
          }
        }
      });
    this.userService.getAllLanguages()
      .subscribe((data: any) => {
        this.languages = data;
        this.languages = this.languages.filter((lang: any) => {
          return lang.languageId !== this.userService.userInfo.defaultLanguage;
        });
        for (const language of data) {
          if (language.languageId === this.userService.userInfo.defaultLanguage) {
            this.displayLanguage = language;
            break;
          }
        }
      });
    this.selectedCountry = this.userService.userInfo.defaultCountry;
    this.selectedLanguage = this.userService.userInfo.defaultLanguage;
    this.storers = ['NIKE', 'nike1'];
    this.selectedStorer = 'NIKE';
    // this.userService.userInfo.userRestrictions
  }
  public updateUserPreference(){
    this.userService.getUserPreferences()
    .subscribe((data: any) => {
      if(data.defaultCountryId != this.userService.userInfo.defaultCountry ){
        this.selectedCountry = data.defaultCountryId;
        this.selectedLanguage = data.defaultLanguageId;
        this.saveCntryLang();
      } else {
        this.retrieveCountryLangList();
      }
    });
  }
  public downloadErrorLog() {
    let log  = this.loggerService.errorLog.toString();
    if(log === ""){
      this.alertService.clearAll().warn(this.resourceService.translateServerResponse("msg_error_log"));
    } else {
      saveAs(new Blob([log], { type: "text" }), 'error.log');
    }
    // this.loggerService.errorLog = [];

  }

  public helpPopup() {
    this.alertService.clearAll();
    const modalRef: any = this.sharedServiceRegistry.sceModalService
      .showModal(HelpPopupComponent,
        {
          overlayHeader: 'Help',
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 840
        });
        modalRef.content.initialize();
    // modalRef.content.showLookup = true;
  }

  // MFA Methods
  public loadMfaStatus(): void {
    const userName = this.userService.userInfo.userName;
    if (!userName) {
      this.mfaStatus = null;
      return;
    }
    this.mfaStatusLoading = true;
    this.mfaService.getMfaStatusForUser(userName).subscribe(
      (response: any) => {
        this.mfaStatus = response;
        this.mfaStatusLoading = false;
        this.getMfaStatusText();
      },
      (error: any) => {
        this.mfaStatus = null;
        this.mfaStatusLoading = false;
      }
    );
  }

  public openMfaManagement(): void {
    this.showMfaSetup = true;
    this.loadMfaStatus();
  }

  public onMfaSetupClose(): void {
    this.showMfaSetup = false;
    // Refresh status when modal closes
    this.loadMfaStatus();
  }

  public onMfaSetupComplete(success: boolean): void {
    // Refresh status - modal handles its own messages now
    this.loadMfaStatus();
  }

  public getMfaStatusText(): string {
    if (this.mfaStatusLoading) {
      this.mfaStatusText = this.getLabel('lbl_mfa_loading');
      return 'Loading...';
    }
    if (this.mfaStatus && this.mfaStatus.setupCompleted) {
      this.mfaStatusText = this.getLabel('lbl_mfa_enabled');
      return 'Enabled';
    }
    this.mfaStatusText = this.getLabel('lbl_mfa_setup_required');
    return 'Setup Needed';
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/profile/profile.component.ts